import controller_0 from '@symfony/ux-chartjs/dist/controller.js';
export default {
  'symfony--ux-chartjs--chart': controller_0,
};